export const sortDataFn = (a, b) => a[0] - b[0];
//# sourceMappingURL=sortDataFn.js.map